




































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import router from "@/router";
import rest from "@/rest";
import { PortalUserVM } from "@/interfaces/PortalUserVM";
import { namespace } from "vuex-class";

@Component({
  components: {
  }
})
export default class GdprApproval extends Vue {
  agreeToAiUsage = false;
  showAiUsageDlg = false;

  async onAgree() {
    let result = await rest.url("auth/agreeToAiUsage").post();
      if (result == true) {
      this.$store.commit("ux/SB_SUCCESS", {
        message: "Zustimmung gespeichert",
        timeout: 3000
      });
    }
    // Update user
    let portalUser: PortalUserVM = await rest.url("Auth/getPortalUser").get();
    if (portalUser != null)
      this.$store.commit("auth/setPortalUser", portalUser);
    // goto contentCreator
    router.push("/contentCreator");
  }

  goBack() {
      router.go(-1);
    }
  }
